// extracted by mini-css-extract-plugin
export default {"wrapper":"Successfully_wrapper__nhgMi","title":"Successfully_title__EEBbA","hline":"Successfully_hline__cSeyG"};